import Swiper from 'swiper';
import {
  hideRequestInfoButton,
  hideRequestSampleButton,
  hideSampleTypesSelect,
  showRequestInfoButton,
  showRequestSampleButton,
  showSampleTypesSelect,
} from '../spree/dom';

// Swiper Default slider
const init = function(swiperId) {
  function disableCarousel(number) {
    const swiperWrapper = document.querySelector('.hero .swiper-wrapper');
    const swiperPagination = document.querySelector('.hero .swiper-pagination');
    const swiperArrows = document.querySelector('.hero .swiper__arrows');
    const disabledClass = 'is-disabled';
    if (number <= 1) {
      swiperWrapper.classList.add(disabledClass);
      swiperPagination.classList.add(disabledClass);
      swiperArrows.classList.add(disabledClass);
    }
  }
  const defaultSwiper = new Swiper(swiperId, {
    slidesPerView: 1,
    loop: true,
    speed: 500,
    grabCursor: true,
    watchSlidesProgress: true,
    keyboard: {
      enabled: true,
    },
    on: {
      slideChange: function() {
        const currentSlide = this.slides[this.activeIndex],
          sampleTypeControllingImage = currentSlide.querySelector(
            'img[data-image-id]'
          );

        // See sample-types-select/index for why there is a stupid hack.
        if (
          this.params.hasOwnProperty('stupidHack') &&
          this.params.stupidHack &&
          sampleTypeControllingImage &&
          sampleTypeControllingImage.getAttribute('data-sample-type-id')
        ) {
          const sampleTypeOption = document.querySelector(
            `.js-sample-types-select option[data-image-id="${sampleTypeControllingImage.getAttribute(
              'data-image-id'
            )}"]`
          );

          if (!sampleTypeOption) {
            hideSampleTypesSelect();
            hideRequestSampleButton();
            showRequestInfoButton();

            return;
          }

          const listItem = sampleTypeOption.parentElement.parentElement.querySelector(
            `li[rel="${sampleTypeOption.value}"]`
          );

          if (!listItem) return;

          hideRequestInfoButton();
          showSampleTypesSelect();
          showRequestSampleButton();

          listItem.dispatchEvent(new Event('click'));
        }
      },
    },
    pagination: {
      el: '.js-swiper-pagination',
      type: 'fraction',
      // Prefix pagination numbers less than 10 with a 0
      formatFractionCurrent: function(number) {
        const prefixedNumber = number < 10 ? `0${number}` : number;
        return prefixedNumber;
      },
      formatFractionTotal: function(number) {
        const prefixedNumber = number < 10 ? `0${number}` : number;
        disableCarousel(number);
        return prefixedNumber;
      },
    },
    navigation: {
      nextEl: '.js-swiper-button-next',
      prevEl: '.js-swiper-button-prev',
    },
  });
};

export default {
  init,
};
